;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('CancelInvoiceController', CancelInvoiceController)

  CancelInvoiceController.$inject = ['$uibModalInstance', 'objType']

  function CancelInvoiceController ($uibModalInstance, objType) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse
      })
      init()
    }

    function init () {
      self.objType = objType
      if (self.objType === 'invoice') {
        self.objLabel = 'la facture'
      }
    }

    function accept () {
      $uibModalInstance.close(true)
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    _.extend(self, {
      cancel: cancel,
      accept: accept,
      refuse: refuse
    })
  }
})(window.angular, window._)
